// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b324a6fd","703":"0ade3420"}[chunkId] + ".chunk.js";
};